import React from "react"

/** Used to provide the clicked startTime/techId to the NewAppointment dialog */
const CalendarContext = React.createContext({
  info: null, // { start: Date(), resourceId: "technicianId" }
  setClicked: () => {},
})

export default CalendarContext
